import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../css/Breadcrumbs.css';

/**
 * Breadcrumbs - Хлібні крихти для навігації та SEO
 * 
 * Покращує:
 * - Навігацію користувачів
 * - SEO через structured data (BreadcrumbList)
 * - UX через зрозумілу структуру сайту
 * 
 * Best Practices 2025:
 * - Schema.org BreadcrumbList
 * - Semantic HTML
 * - ARIA для доступності
 * 
 * @param {Array} items - Масив елементів [{name, path}, ...]
 */
const Breadcrumbs = ({ items = [] }) => {
    if (!items || items.length === 0) {
        return null;
    }

    const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://union-auto.com.ua';

    // Structured data для Google Rich Snippets
    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.path ? `${siteUrl}${item.path}` : undefined
        }))
    };

    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbSchema)}
                </script>
            </Helmet>
            
            <nav aria-label="Хлібні крихти" className="breadcrumbs">
                <ol className="breadcrumb-list">
                    {items.map((item, index) => (
                        <li key={index} className="breadcrumb-item">
                            {item.path && index < items.length - 1 ? (
                                <>
                                    <Link to={item.path} className="breadcrumb-link">
                                        {item.name}
                                    </Link>
                                    <span className="breadcrumb-separator" aria-hidden="true"> / </span>
                                </>
                            ) : (
                                <span className="breadcrumb-current">{item.name}</span>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
        </>
    );
};

export default Breadcrumbs;

